export const StrongTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getStrongBase: () => 'strong',
    // for test id generation
    getStrongTestId: (testId) => [StrongTestIdFactory.getStrongBase(), testId].join('-'),
};
